import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class FineService {
  baseUrl: string = environment.api_base_url;
  constructor(public http: HttpClient) {}

  getFines(params = {}): any {
    return this.http.get(`${this.baseUrl}fines`, {
      params: Object.entries(params)
        .filter(([key, val]) => val)
        .reduce((obj, [key, val]) => {
          obj[key] = val;
          return obj;
        }, {}),
    });
  }

  getFine(id, params = {}): any {
    return this.http.get(`${this.baseUrl}fines/${id}`, {
      params,
    });
  }

  addFine(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/store_violation_fine`,
      payload
    );
  }

  collectFine(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/collect`,
      payload
    );
  }

  deleteFine(reservation_id, payload = {}): any {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/delete`,
      payload
    );
  }

  changeApprovedStatus(reservation_id, payload) {
    return this.http.post(
      `${this.baseUrl}fines/${reservation_id}/change_fine_status`,
      payload
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/fines-view/fine.service.ts